// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_Ivw","cls2":"CoScientistPricingPage-cls2_HIB CoScientistPricingPage-cls1_Ivw"};